import { Checkbox, Divider, FormControlLabel, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Card } from "reactstrap";
import HoverToDisplayFullTitle from "../../../reusableComponents/HoverToDisplayFullTitle";
import { colorBrandObject } from "../../../../constants/brandings";

const PaymentCards = ({
  obj,
  allChecked,
  count,
  setCount,
  selects,
  setSelects,
  clickedAll,
  handleAllCheck,
  paymentOptionsIds,
  pspCode,
}) => {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(clickedAll);
  }, [clickedAll]);

  useEffect(() => {
    if (selects?.find((ele) => ele.id == obj.id)) {
      setChecked(true);
    } else setChecked(false);
  }, []);

  const handleChange = () => {
    if (checked) {
      setCount(count - 1);
      setSelects((selects) => selects.filter((v) => v.id != obj.id));
    } else {
      const items = [
        {
          title: obj.title,
          id: obj.id,
          type: obj.type,
          typeTitle: obj.typeTitle,
          logoUrl: obj.logoUrl
        },
      ];

      if (!selects?.find((ele) => ele.id == items.id)) {
        const newitems = [...selects, ...items];
        setSelects(newitems);
        setCount(count + 1);
      }
    }
  };

  const handleCheckboxChange = (event) => {
    setChecked(event.target.checked);
    handleChange();
  };

  const handleCardClick = () => {
    setChecked(!checked);
    handleChange();
  };
  const [twocolumns, setTwocolumns] = useState(false);
  const [threecolumns, setThreecolumns] = useState(false);
  const [fourcolumns, setFourcolumns] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width : 1300px)");
    setTwocolumns(mediaQuery.matches);
    const updateShouldRenderMobileNavbar = (event) => {
      setTwocolumns(mediaQuery.matches);
    };
    mediaQuery.addEventListener("change", updateShouldRenderMobileNavbar);
  }, []);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width : 1640px)");
    setThreecolumns(mediaQuery.matches);
    const updateShouldRenderMobileNavbar = (event) => {
      setThreecolumns(mediaQuery.matches);
    };
    mediaQuery.addEventListener("change", updateShouldRenderMobileNavbar);
  }, []);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width : 1910px)");
    setFourcolumns(mediaQuery.matches);
    const updateShouldRenderMobileNavbar = (event) => {
      setFourcolumns(mediaQuery.matches);
    };
    mediaQuery.addEventListener("change", updateShouldRenderMobileNavbar);
  }, []);

  return (
    <>
      <div
        style={{
          width: twocolumns
            ? "45%"
            : threecolumns
              ? "32%"
              : fourcolumns
                ? "24%"
                : "18%",
        }}
      >
        <Card
          style={{
            height: "70px",
            padding: "17px",
            marginRight: "20px",
            border: "3px",
            width: "200px",
            cursor: "pointer"
          }}
          onClick={handleCardClick}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-around" }}>
              <img
                src={obj.logoUrl}
                style={{ height: "38px", width: "35px" }}
              />

              <h6
                style={{
                  fontSize: "13px",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100px",
                  maxWidth: "200px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  paddingTop: "13px",
                }}
              >
                {obj?.title ? (
                  <HoverToDisplayFullTitle title={obj?.title} len={10} />
                ) : (
                  <></>
                )}
              </h6>
            </div>
            <div style={{ paddingTop: "-10px" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    size="medium"
                    checked={checked}
                    onChange={handleCheckboxChange}
                    sx={{
                      margin: "0px -32px 0px 0px",
                      width: "40px",
                      height: "40px",
                      '& .MuiSvgIcon-root': {
                        color: colorBrandObject?.secondaryButtonColor,
                      },
                      '&.Mui-checked': {
                        color: colorBrandObject?.secondaryButtonColor,
                        '& .MuiSvgIcon-root': {
                          fill: colorBrandObject?.secondaryButtonColor,
                        },
                      },
                    }}
                  />
                }
              />
            </div>
          </div>
        </Card>
      </div>
    </>
  );
};

export default PaymentCards;
